import { ISchedules } from "./models";

export const scheduleItems: ISchedules[] = [
  {
    id: "1",
    identifier: "10",
  },
  {
    id: "2",
    identifier: "15",
  },
];
